import React from 'react';
import { connect } from 'react-redux';
import { Dialog } from '@mui/material';
import { IAppState } from '../../../state/reducers';
import { IProps, IStateProps, IDispatchProps } from './interfaces';
import VendorData from './VendorData/component';
import { toggleVendorData } from '../../../state/exchange/vendorData';

class ExchangeVendorDataDialog extends React.Component<IProps> {
  render() {
    const {
      isOpen,
      onClose,
    } = this.props;

    return (
      <Dialog
        open={isOpen}
        onClose={onClose}
        fullWidth
        maxWidth="md"
      >
        <VendorData />
      </Dialog>
    );
  }
}

const mapStateToProps = (state: IAppState): IStateProps => ({
  isOpen: state.exchange.vendorData.isOpen,
});

const mapDispatchToProps: IDispatchProps = {
  onClose: toggleVendorData,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ExchangeVendorDataDialog);
